import { getQueryParameterByName } from '@omnia/ui'
import { getFilmById, getShowtimeById } from '@vista-digital/occ-domain/src'
import type { Location, NavigateFunction } from 'react-router-dom-v7'
import { isSignedIn } from '@/common/utils/isSignedIn'
import { navigationService } from '@/content/services/navigation.service'
import type { UrlServiceInterface } from '@/content/services/url.service.interface'
import { ticketingWorkflow } from '@/content/services/workflows/ticketing/ticketing-workflow'
import { isUnallocatedSeating } from '@/content/services/workflows/ticketing/validators/utils/isUnallocatedSeating'

export const handleSeatPickerPageNavigation = (
    currentSubPage: string | undefined,
    navigate: NavigateFunction,
    urlService: UrlServiceInterface,
    location: Location
): boolean => {
    const isFirstPageInAWorkflow = () => {
        // For unallocated seating, the first page is either TicketPicker (if signed in) or TicketingLogin (if not signed in)
        if (isUnallocatedSeating(ticketingWorkflow.State)) {
            if (isSignedIn() && currentSubPage === 'TicketPicker') return true
            if (!isSignedIn() && currentSubPage === 'TicketingLogin') return true
            return false
        }
        return currentSubPage === 'SeatPicker'
    }

    if (isFirstPageInAWorkflow()) {
        const showtimeId = getQueryParameterByName('showtimeId', location.search)
        if (showtimeId) {
            const showtime = getShowtimeById(showtimeId)
            const filmId = showtime?.filmId
            if (filmId) {
                const film = getFilmById(filmId)
                if (film) {
                    if (location.search.includes('fromQuickNavigator=true')) {
                        // If coming from the quick navigator, go to the homepage
                        void navigate(navigationService.getPageUrl('Home'))
                        return true
                    } else {
                        // Otherwise, navigate to the film details page
                        void navigate(urlService.getFilmDetailsUrl(film))
                        return true
                    }
                }
            }
        }
    }
    return false
}
